<template>
  <div class="page">
    <div class="title">
      部门
      <div class="right">
        <Button @click.native="handleClickReset"   style="margin-right:20px">重置</Button>
        <Button @click.native="handleClickSearch"  :loading="isLoading1" style="margin-right:20px">搜索</Button>
        <Button @click="showAdd = true" type="primary">新增部门</Button>
      </div>
    </div>
    <search :depts="depts" ref="search" />
    <list @onClickDel="onClickDel" @onPageChange="onPageChange" :isLoading="isLoading1" :data="data" :total="total" style="margin-top:20px" />
    <Modal @on-visible-change="onVisibleChange" :value="showAdd" title="新增部门">
      <Form>
        <FormItem label="部门类别">
          <Select  v-model="formData.deptType">
            <Option  v-for="item in depts" :value="item.id" :key="item.id">{{item.dicName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="部门名称">
          <Input v-model="formData.deptName" />
        </FormItem>
        <FormItem label="部门描述">
          <Input v-model="formData.remark" type="textarea" :rows="10" />
        </FormItem>
      </Form>
      <section slot="footer">
        <Button  @click.native="showAdd = false"  style="margin-right:20px">取消</Button>
        <Button :loading="isLoading" @click="handleClickAddDept" type="primary">确定</Button>
      </section>
    </Modal>
  </div>
</template>

<script>
import Search from "./Search";
import List from "./List";
import api from "../../../api/index";
const { getDeptTableList, getDeptList, addDept ,delDept} = api;
export default {
  data() {
    return {
      showAdd: false,
      formData: {
        deptName: "",
        deptType: '',
        remark: ''
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      data: [],
      depts: [],
      isLoading: false,
      isLoading1: false,
      searchForm: {

      }
    };
  },
  components: {
    Search,
    List
  },
  methods: {
    handleClickSearch() {
      let searchForm = this.$refs.search.formData;
      this.searchForm = searchForm
      
      this.getDeptTableList()
    },
    onClickDel(id) {
      this.delDept(id)
    },
    async delDept(id) {
      try{
        let res = await this.$delete(delDept, {idList: id})
        this.$Message.success('删除成功')
        this.getDeptTableList()
      }finally{

      }
    },
    handleClickReset() {
      this.$refs.search.reset()
    },
    onPageChange(page) {

      this.pageNum = page
      this.getDeptTableList()
    },
    async getDeptTableList() {
     
      this.isLoading1 = true

      try{
        let res = await this.$post(getDeptTableList, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchForm
      });
      this.data = res.rows;
      this.total = res.total;
      }finally{
        this.isLoading1 = false
      }
    },
    async getDeptList() {
      let res = await this.$get(getDeptList);
      this.depts = res.rows;
    },
    onVisibleChange(e) {
      if(!e){
        this.showAdd = false
        for(let key in this.formData){

          this.formData[key] = ''
        }
      }
    },
    async handleClickAddDept() {
      try{
        this.isLoading = true
        let res = await this.$post(addDept, this.formData)
        this.$Message.success('添加成功')
        this.getDeptTableList()
        this.showAdd = false
      }finally{
        this.isLoading =false
      }
    }
  },
  created() {
    this.getDeptList();
    this.getDeptTableList();
  }
};
</script>


<style  scoped lang="less">
.page {
  padding: 0 20px;
}
.title {
  text-align: center;
  height: 85px;
  line-height: 85px;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  .right {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }
}
</style>